'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var truncate = require('lodash/truncate');
var styled = require('styled-components');
var MuiAutocomplete = require('@mui/material/Autocomplete');
var TextField = require('@mui/material/TextField');
var MuiCheckbox = require('@mui/material/Checkbox');
var FormControlLabel = require('@mui/material/FormControlLabel');
var components_Body2_index = require('../Body2/index.js');
var checkboxChecked = require('../../checkbox-checked-01411b46.js');
var caretDown = require('../../caret-down-3cd041e8.js');
var helpers_styles = require('../../helpers/styles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var truncate__default = /*#__PURE__*/_interopDefaultLegacy(truncate);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var MuiAutocomplete__default = /*#__PURE__*/_interopDefaultLegacy(MuiAutocomplete);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var MuiCheckbox__default = /*#__PURE__*/_interopDefaultLegacy(MuiCheckbox);
var FormControlLabel__default = /*#__PURE__*/_interopDefaultLegacy(FormControlLabel);

var ICON_VIEWBOX = "0 0 22 22";
var iconStyles = styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  height: 18px;\n  width: 18px;\n"], ["\n  height: 18px;\n  width: 18px;\n"])));
var CheckboxEmptyIcon = styled__default["default"](checkboxChecked.SvgCheckboxEmpty).attrs({
    viewBox: ICON_VIEWBOX,
})(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), iconStyles);
var CheckboxCheckedIcon = styled__default["default"](checkboxChecked.SvgCheckboxChecked).attrs({
    viewBox: ICON_VIEWBOX,
})(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), iconStyles);
var CaretDownIcon = styled__default["default"](caretDown.SvgCaretDown).attrs({
    alt: 'caret-down-icon',
    title: 'A caret-down-icon in select menu',
})(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject([""], [""])));
var SelectedValueText = styled__default["default"](components_Body2_index["default"])(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  padding-left: 6px;\n"], ["\n  padding-left: 6px;\n"])));
var SelectContainer = styled__default["default"](MuiAutocomplete__default["default"])(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  ", ";\n  ", ";\n\n  .MuiInputLabel-shrink {\n    color: ", ";\n  }\n\n  &.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: ", ";\n  }\n  &.Mui-focused .MuiInputLabel-shrink {\n    color: ", ";\n  }\n\n  .MuiAutocomplete-popupIndicator {\n    color: ", ";\n    ", " {\n      path {\n        fill: ", ";\n      }\n    }\n  }\n  .MuiAutocomplete-popupIndicatorOpen {\n    ", " {\n      path {\n        fill: ", ";\n      }\n    }\n    transform: none;\n  }\n\n  .Mui-disabled {\n    ", " {\n      color: ", ";\n    }\n  }\n\n  .Mui-disabled.MuiAutocomplete-popupIndicator {\n    ", " {\n      path {\n        fill: ", ";\n      }\n    }\n  }\n  .Mui-disabled.MuiInputLabel-shrink {\n    color: ", ";\n  }\n"], ["\n  ", ";\n  ", ";\n\n  .MuiInputLabel-shrink {\n    color: ", ";\n  }\n\n  &.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: ", ";\n  }\n  &.Mui-focused .MuiInputLabel-shrink {\n    color: ", ";\n  }\n\n  .MuiAutocomplete-popupIndicator {\n    color: ", ";\n    ", " {\n      path {\n        fill: ", ";\n      }\n    }\n  }\n  .MuiAutocomplete-popupIndicatorOpen {\n    ", " {\n      path {\n        fill: ", ";\n      }\n    }\n    transform: none;\n  }\n\n  .Mui-disabled {\n    ", " {\n      color: ", ";\n    }\n  }\n\n  .Mui-disabled.MuiAutocomplete-popupIndicator {\n    ", " {\n      path {\n        fill: ", ";\n      }\n    }\n  }\n  .Mui-disabled.MuiInputLabel-shrink {\n    color: ", ";\n  }\n"])), helpers_styles.muiInputWidthStyles, helpers_styles.muiInputHeightStyles, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, function (_a) {
    var link = _a.theme.colors.text.link;
    return link;
}, function (_a) {
    var link = _a.theme.colors.text.link;
    return link;
}, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, CaretDownIcon, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, CaretDownIcon, function (_a) {
    var link = _a.theme.colors.text.link;
    return link;
}, SelectedValueText, function (_a) {
    var disabled = _a.theme.colors.text.disabled;
    return disabled;
}, CaretDownIcon, function (_a) {
    var disabled = _a.theme.colors.text.disabled;
    return disabled;
}, function (_a) {
    var disabled = _a.theme.colors.text.disabled;
    return disabled;
});
var StyledTextField = styled__default["default"](TextField__default["default"])(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), helpers_styles.muiInputPaddingStyles, helpers_styles.muiInputDisabledStyles, helpers_styles.muiInputErrorStyles, helpers_styles.muiInputBorderStyles, helpers_styles.muiInputTextStyles);
var StyledCheckbox = styled__default["default"](MuiCheckbox__default["default"]).attrs({
    disableRipple: true,
    icon: React__default["default"].createElement(CheckboxEmptyIcon, null),
    checkedIcon: React__default["default"].createElement(CheckboxCheckedIcon, null),
})(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  :hover,\n  &.Mui-checked:hover {\n    background-color: ", ";\n  }\n"], ["\n  :hover,\n  &.Mui-checked:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var primary = _a.theme.colors.background.primary;
    return primary;
});
var DropdownWrapper = styled__default["default"].div(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: ", ";\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n"])), function (_a) {
    var primary = _a.theme.colors.background.primary;
    return primary;
}, function (_a) {
    var shadows = _a.theme.shadows;
    return shadows[2];
});
var LabelText = styled__default["default"](components_Body2_index["default"])(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n  display: inline-block;\n  margin-left: 5px;\n"], ["\n  display: inline-block;\n  margin-left: 5px;\n"])));
var StyledFormControlLabel = styled__default["default"](FormControlLabel__default["default"])(templateObject_11 || (templateObject_11 = tslib_es6.__makeTemplateObject(["\n  margin-right: 0;\n"], ["\n  margin-right: 0;\n"])));
var Checkbox = function (_a) {
    var children = _a.children, checked = _a.checked;
    return (React__default["default"].createElement(StyledFormControlLabel, { value: checked, control: React__default["default"].createElement(StyledCheckbox, { checked: checked }), label: React__default["default"].createElement(LabelText, null, children) }));
};
var childrenToText = function (children) {
    return React__default["default"].Children.toArray(children).join('');
};
var Select = React__default["default"].forwardRef(function (_a, ref) {
    var className = _a.className, c = _a.children, autocomplete = _a.autocomplete, multiple = _a.multiple, placeholder = _a.placeholder, name = _a.name, label = _a.label, error = _a.error, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.readOnly, readOnly = _c === void 0 ? false : _c, onChange = _a.onChange, _d = _a.value, value = _d === void 0 ? multiple ? [] : '' : _d;
    var _e = React.useState(false), isOpen = _e[0], setIsOpen = _e[1];
    var children = React__default["default"].Children.toArray(c);
    var renderCheckbox = function (props, option_component, value) {
        var children = option_component.props.children;
        return (React__default["default"].createElement("li", tslib_es6.__assign({}, props),
            React__default["default"].createElement(Checkbox, { checked: value.selected }, childrenToText(children))));
    };
    var renderOption = function (props, option_component) { return React__default["default"].cloneElement(option_component, props); };
    // 05/2021 - Material UI does not work when the value
    // is of a different type than the options object. Therefore
    // this hack is needed to improve the API of our Select component
    var findMatchingOptions = function (_a) {
        var options = _a.options, value = _a.value, multiple = _a.multiple;
        return multiple
            ? options.filter(function (_a) {
                var option_value = _a.props.value;
                return value.some(function (choice) { return option_value === choice; });
            })
            : options.find(function (_a) {
                var option_value = _a.props.value;
                return option_value === value;
            });
    };
    var getDefaultValue = function (_a) {
        var multiple = _a.multiple;
        return multiple ? [] : null;
    };
    var filterOptions = MuiAutocomplete.createFilterOptions({
        stringify: function (option) {
            var option_component = option;
            return "".concat(childrenToText(option_component.props.children)).concat(option_component.props.subheader || '').concat(option_component.props.group || '', "\n      ");
        },
    });
    return (React__default["default"].createElement(SelectContainer, { ref: ref, role: undefined, blurOnSelect: !multiple, className: className, popupIcon: React__default["default"].createElement(CaretDownIcon, null), filterOptions: filterOptions, groupBy: function (option) {
            var option_component = option;
            return option_component.props.group;
        }, openOnFocus: true, PaperComponent: function (_a) {
            var children = _a.children;
            return (React__default["default"].createElement(DropdownWrapper, null, children));
        }, onOpen: function () { return setIsOpen(true); }, onClose: function () { return setIsOpen(false); }, multiple: multiple, options: children, disableClearable: true, disableCloseOnSelect: multiple, value: findMatchingOptions({ options: children, value: value, multiple: multiple }) ||
            getDefaultValue({ multiple: multiple }), getOptionLabel: function (option) {
            var _a;
            var option_component = option;
            return childrenToText((_a = option_component === null || option_component === void 0 ? void 0 : option_component.props) === null || _a === void 0 ? void 0 : _a.children);
        }, onChange: function (_event, option) {
            var selected_option = option;
            onChange &&
                onChange(Array.isArray(selected_option)
                    ? selected_option.map(function (_a) {
                        var value = _a.props.value;
                        return value;
                    })
                    : selected_option.props.value);
        }, disabled: disabled, renderInput: function (params) { return (React__default["default"].createElement(StyledTextField, tslib_es6.__assign({}, params, { error: !!error, fullWidth: true, helperText: error, FormHelperTextProps: {
                'aria-live': 'assertive',
            }, id: name, label: label, name: name, placeholder: value ? undefined : placeholder, variant: "outlined", inputProps: tslib_es6.__assign(tslib_es6.__assign({}, params.inputProps), { id: "".concat(name, "-textfield"), autoComplete: autocomplete, 'aria-expanded': isOpen ? 'true' : 'false', role: 'combobox', readOnly: readOnly }), InputLabelProps: tslib_es6.__assign(tslib_es6.__assign({}, params.InputLabelProps), { id: "".concat(name, "-textfield-label"), htmlFor: "".concat(name, "-textfield") }) }))); }, renderTags: function (value) {
            if (typeof value === 'string') {
                return React__default["default"].createElement(SelectedValueText, null, value);
            }
            var tags = value;
            var num_tags = tags.length;
            var first_choice = tags[0];
            return (React__default["default"].createElement(SelectedValueText, null,
                truncate__default["default"](childrenToText(first_choice.props.children), {
                    length: 25,
                }),
                num_tags > 1 && " +".concat(num_tags - 1)));
        }, renderOption: function (props, option, state) {
            return multiple
                ? renderCheckbox(props, option, state)
                : renderOption(props, option);
        } }));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;

exports["default"] = Select;
